module.exports = __webpack_public_path__ + "media/images/cianan-4e4c3052e6250a00aa45e1ae4f4740d8.png";